import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { API_BASE_URL } from '@core/api/api.tokens';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Observable, catchError, switchMap, throwError } from 'rxjs';

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const api = inject(API_BASE_URL).replace(/\/$/, '');
    // Login/refresh and external resources must not enter the protected-request flow.
    if (req.url !== api && !req.url.startsWith(api + '/')) return next(req);
    const redirect = () => {
        const redirectURL = router.url;
        auth.signOut();
        void router.navigate(['/sign-in'], { queryParams: { redirectURL } });
    };
    const send = () =>
        next(auth.accessToken ? req.clone({ setHeaders: { Authorization: 'Bearer ' + auth.accessToken } }) : req).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse && error.status === 401) redirect();
                return throwError(() => error);
            })
        );
    if (auth.accessToken && !AuthUtils.isTokenExpired(auth.accessToken)) return send();
    if (!auth.refreshToken) return send();
    // Refresh before sending a protected request; never replay a mutation after a 401.
    return auth.signInUsingToken().pipe(
        switchMap((valid) => {
            if (valid) return send();
            void router.navigate(['/sign-in'], { queryParams: { redirectURL: router.url } });
            return throwError(() => new HttpErrorResponse({ status: 401, statusText: 'Session refresh unavailable' }));
        })
    );
};
